<template>
    <website-page>
        <wifi-navigation></wifi-navigation>

        <div class="main-section overlay">
            <b-container>
                <h1 class="blured">
                    <span v-tr>Coach and Bus WiFi Solutions|Solutions wifi pour les bus et transports</span>
                </h1>
                <h2 class="subtitle blured" v-tr>
                    Simple out-of-the-box deployment of public WiFi on public transit, coach-lines, shuttles, school-buses and other passenger transportation vehicles and stations|
                    Déploiement prêt à l'emploi et facile du WiFi public sur les transports en commun, les lignes d'autocars, les navettes, les autobus scolaires et autres véhicules et gares de transport de passagers
                </h2>
                <p class="presentation" v-tr>
                    Today, WiFi is a necessity while on the road and most passengers are expecting it.
                    We are offering a turnkey solution including hardware, software, Internet connection, installation and technical support to provide your passengers with connectivity and you with tools for promoting, engaging, and geolocating.|
                    Aujourd'hui, le WiFi est une nécessité sur la route et la plupart des passagers s'y attendent.
                    Nous proposons une solution clé en main comprenant du matériel, des logiciels, une connexion Internet, une installation et un support technique pour fournir à vos passagers une connectivité et à vous des outils de promotion, d'engagement et de géolocalisation.
                </p>
                <b-row class="mt-5">
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/eye-in-client-leduc.png')" alt="Eye-In Bus Client Ledus"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/eye-in-client-king-charters.png')" alt="Eye-In Bus Client King Charters"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/eye-in-client-limocar.png')" alt="Eye-In Bus Client Limocar"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/eye-in-client-king-tours.png')" alt="Eye-In Bus Client King Tours"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/transdev.png')" alt="Eye-In Client Transdev"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/stm.png')" alt="Eye-In Client STM"></b-img>
                    </b-col>
                </b-row>
                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#features'" variant="outline-light"><span v-tr>Details and features|Détails et fonctionnalités</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="features" class="page inverted">
            <b-container>
                <h2 class="text-center" v-tr>Main Features for Buses|Fonctionnalités principales pour les bus</h2>
                <h4 class="text-center my-4" v-tr>
                    With our WiFi solution and our specialization in WiFi networks and marketing, not only we meet the needs of your passengers, but we also enable your company to have the flexibility to:|
                    Avec notre solution WiFi et notre spécialisation dans les réseaux WiFi et le marketing, non seulement nous répondons aux besoins de vos passagers, mais nous permettons également à votre entreprise d'avoir la flexibilité de:
                </h4>

                <b-row class="mt-5 text-center">
                    <feature-card src="img/icons/content-filtering.png" alt="Power Filtering System for Guest WiFi">
                        <h4 v-tr>Content Filtering|Filtre de contenu</h4>
                        <p v-tr>
                            Block undesirable content (ie: pornography) from appearing on passenger’s screens to promote a safe environment.|
                            Empêchez le contenu indésirable (par exemple: la pornographie) d'apparaître sur les écrans des passagers afin de promouvoir un environnement sûr.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/tablet.png" alt="Bus Driver Tablets Schedule">
                        <h4 v-tr>Equip Your Drivers with Tablets|Équipez vos chauffeurs de tablettes</h4>
                        <p v-tr>
                            Enable Your Drivers to Fill Out Forms Online (Delays/Schedules)|
                            Vos chauffeurs pourront ainsi remplir des formulaires en ligne (retards/horaires)
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/airplane-ticket.png" alt="Connect Onboard ticket scanners, GPS">
                        <h4 v-tr>Connect Your Bus Devices|Connectez vos équipements</h4>
                        <p v-tr>
                            Connect Your Onboard Ticket Scanners, GPS and Geo-Mapping Devices|
                            Scanneur pour la billetterie à bord, GPS et outils de géolocalisation
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/guest-access-2.png" alt="Promote your Branding and Advertise">
                        <h4 v-tr>Promote your Brand|Faire la promotion de votre marque</h4>
                        <p v-tr>
                            Manage and customize captive WiFi login and welcome pages (for branding/advertising purposes)|
                            Gérez et personnalisez la connexion Wi-Fi captive et les pages d'accueil (à des fins de marque / publicité)
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/gps.png" alt="Geolocation system on map for buses">
                        <h4 v-tr>Geolocate your buses|Géolocalisez vos bus</h4>
                        <p v-tr>
                            View your buses in real time on a map, view their path and coordinate better with your drivers.|
                            Visualisez vos bus en temps réel sur une carte, visualisez leur trajet et coordonnez mieux avec vos chauffeurs.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/roulette.svg" alt="Engage with your passengers with surveys and contests">
                        <h4 v-tr>Engage with your passengers|Entrez en contact avec vos passagers</h4>
                        <p v-tr>
                            Engage with your passengers through contests, your Facebook page or surveys before they can even log on to your WiFi.|
                            Interagissez avec vos passagers via des concours, votre page Facebook ou des sondages avant même qu'ils ne puissent se connecter à votre WiFi.
                        </p>
                    </feature-card>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#transportation'" variant="outline-light"><span v-tr>About WiFi On Board|À propos du WiFi à bord</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="transportation" class="page">
            <b-container>
                <h2 class="text-center mb-5" v-tr>Onboard WiFi solution|Solution WiFi à bord</h2>

                <b-row>
                    <b-col md="7">
                        <h4 v-tr>
                            We help you provide your passengers with the best wifi solutions|
                            Nous vous aidons à proposer le meilleur réseau wifi à vos voyageurs
                        </h4>
                        <p class="text-justify" v-tr>
                            <b>For over 15 years</b> now, we have been a reliable business partner when it comes to <b>WiFi solutions in transports</b>, whether for schools, recreational, urban, interurban, charter or adapted transport. Using the Eye-Intelligence dashboard, manage all your network connections in real time and track your buses' geolocation.|
                            <b>Depuis plus de 15 ans</b> maintenant, nous sommes un partenaire de choix pour les <b>solutions Wi-fi dans les transports</b>, qu’il s’agisse du domaine scolaire, des loisirs, urbain, interurbain, nolisé ou du transport adapté. À partir de notre outil Eye-Intelligence, gérez toutes vos connexions et suivez la localisation de tous vos bus.
                        </p>
                        <p class="text-justify" v-tr>
                            We offer you a <b>turnkey solution</b> with selection of equipment, selection of internet connection, installation, support and marketing / ROI strategy.
                            We remain on board at all times so that you are at the technical and marketing level at the cutting edge of technology in the short and long term.|
                            Nous vous offrons une <b>solution clé en main</b> avec sélection d’équipements, sélection de connexion internet, installation, support et stratégie marketing/ROI.
                            Nous restons à bord en tout temps afin que vous soyez au niveau technique et marketing à la fine pointe de la technologie à court et à long terme.
                        </p>

                        <p v-tr>
                            Our pending patent includes 330 Claims that not only extends to WiFi for in-establishment marketing, but also extends to Cellular networks that operate over a widespread geography.|
                            Notre <b>brevet en cours</b> comprend 330 revendications qui ne s’étendent pas seulement au WiFi pour le marketing en établissement, mais s’étendent également aux réseaux cellulaires qui fonctionnent sur une zone géographique étendue.
                        </p>

                        <hr class="mt-4 mb-0">

                        <e-img src="img/clients-color/transportation/transdev.png" alt="Eye-In Client Bus Transdev"></e-img>
                        <blockquote class="blockquote">
                            <p class="mb-0">
                                "<span v-tr>Thank you Eye-In Media for outstanding services since 2007.
                                    Your dynamic and competent team remarkably understands how to concretize your customers’ requirements.|
                                    Merci Eye-In Media pour vos précieux services depuis 2007. Avec votre équipe dynamique et compétente qui comprend et concrétise les besoins de ses clients.
                                </span>"
                            </p>
                            <footer class="blockquote-footer mt-2"><b class="mr-2">Sébastien BOUDRIAS</b> <cite title="Source Title" v-tr>Chief Digital Officer Transdev Canada|Directeur informatique et télécommunications de Transdev Canada</cite></footer>
                        </blockquote>

                    </b-col>
                    <b-col>
                        <e-img fluid rounded src="img/screenshots/bus-journey.png" class="banner" style="max-width: 100%; max-height: 500px;"
                               alt="Bus Geolocation Tracking and Journey"></e-img>
                    </b-col>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#eyein-and-wifi'" variant="light"><span v-tr>Eye-In and WiFi|Eye-In et le WiFi</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="eyein-and-wifi" class="page inverted text-center">
            <b-container>
                <h3 class="text-center" v-tr>Eye-In and WiFi|Eye-In et le WiFi</h3>

                <b-row>
                    <b-col cols="12" lg="6">
                        <p class="presentation text-justify" v-tr>
                            Providing WiFi on board requires technical and marketing expertise. Eye-In Media has these two areas of expertise.|
                            Offrir du WiFi à bord demande une expertise technique et marketing. Eye-In Média possède ces deux expertises.
                        </p>
                        <p class="presentation text-justify" v-tr>
                            For over fifteen years, we have been installing, managing, maintaining and making profitable the WiFi of several transport companies and other industries. Thus, we manage tens of millions of WiFi connections.|
                            Depuis plus de quinze ans, nous installons, gérons, assurons la maintenance et rentabilisons le WiFi de plusieurs compagnies de transport et autres industries. Ainsi, nous gérons des dizaines de millions de connexions WiFi.
                        </p>
                        <p class="presentation text-justify" v-tr>
                            With our <b>on-board WiFi solution</b> and our expertise in WiFi networking and marketing, you will not only meet the needs of your passengers, but you will gain from it internally in different ways.|
                            Avec notre <b>solution WiFi à bord</b> et notre expertise en réseaux WiFi et marketing, non seulement vous répondrez aux besoins de vos passagers, mais vous y gagnerez à l’interne de différentes façons.
                        </p>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-img rounded fluid-grow :src="require('../../assets/img/examples/montreal-city-bus-wifi.jpg')" style="max-height: 250px; object-fit: cover;"></b-img>
                        <p class="mt-2" v-tr>
                            In 2014, Eye-In launched the <b>first WiFi-equipped city bus in Montréal</b> in partnership with Distributel.|
                            En 2014, Eye-In a lancé le <b>premier bus urbain équipé WiFi à Montréal</b> en partenariat avec Distributel.
                        </p>
                        <a href="https://globalnews.ca/news/1322207/montreal-rolls-out-its-first-wifi-equipped-city-bus/" target="_blank"><span v-tr>Read article|Lire l'article</span> <i class="fal fa-chevron-right ml-1"></i></a>
                    </b-col>
                </b-row>

                <hr class="mt-4 mb-0">

                <b-img :src="require('../../assets/img/clients-color/transportation/king_charters.png')" alt="Eye-In Client Bus King Charters"></b-img>
                <blockquote class="blockquote">
                    <p class="mb-0">
                        "<span v-tr>
                            Strong and reliable internet coverage. Eye-in Media's monthly fees are very reasonable, and they don't have hidden fees.
                            If you don't have WiFi on your bus you are making a mistake. Eye-in Media will get you set-up quickly. King Charters has been using Eye-in Media for over a year. We are so happy with the service we would not consider another company.|
                            Couverture Internet solide et fiable. Les frais mensuels d'Eye-in Media sont très raisonnables et ne comportent pas de frais cachés.
                            Si vous n'avez pas de WiFi dans votre bus, vous faites une erreur. Eye-in Media vous permettra de vous installer rapidement. King Charters utilise Eye-in Media depuis plus d'un an. Nous sommes tellement satisfaits du service que nous ne considérerions pas une autre entreprise.
                        </span>"
                    </p>
                    <footer class="blockquote-footer mt-2"><b class="mr-2">Robert</b> <cite title="Source Title">King Charters</cite></footer>
                </blockquote>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-3" v-scroll-to="'#clients'" variant="outline-light"><span v-tr>Our Clients|Nos clients</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="clients" class="page">
            <b-container>
                <h3 class="text-center" v-tr>They chose us|Ils nous ont choisis</h3>
                <wifi-transportation-client-cards></wifi-transportation-client-cards>

                <div class="text-center">
                    <br>
                    <router-link class="mt-3" :to="'/wifi/clients|/wifi-public/marches-et-clients'|tr" variant="primary"><span v-tr>All our clients and markets|Tous nos clients et marchés</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    <br>
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#contact-us'" variant="light"><span v-tr>Contact Us|Nous contacter</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import WifiTransportationClientCards from "@/client-cards/wifi-transportation-client-cards.vue";

    import WifiNavigation from "@/navigation/wifi-navigation.vue";
    import {translate} from "../../../vue-components/helpers/i18n.js";
    export default {
        name: `wifi-transportation`,
        components: {WifiTransportationClientCards, WifiNavigation},
        metaInfo: {
            title: translate(`WiFi Aboard: Transports and Bus WiFi Solutions|WiFi à bord: Solutions WiFi pour transports et bus`),
            meta: [
                { name: `keywords`, content: `transport, bus, transports, marketing, wifi, on board, aboard, geolocation, gps, passengers, tourists` },
                { name: `description`, content: translate(`Provide your bus passengers or tourists with the Best WiFi Solutions|Offrez à vos passagers de bus ou touristes les meilleures solutions WiFi`) }
            ]
        },
        activated() {
            if (this.$route.params.section) {
                this.$scrollTo(`#${this.$route.params.section}`);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/style/bootstrap-theme";

    .main-section {
        background-color: #151e28;
        background-image: url('../../assets/img/backgrounds/transportation-blue.jpg');
        background-image: url('../../assets/img/backgrounds/transportation-blue.webp');
        background-size: cover;
    }

    .icon-list {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .fal,
        .fas {
            opacity: 0.8;
            font-size: 36px;
            padding: 15px;
            display: inline-flex;
            margin: 0 auto;
        }
    }
</style>
